import React, { useEffect } from "react";
import { FormField } from "./FormField";
import styles from "./styles.module.scss";
import { useFormStore } from "src/store/dataEntryForm";
import { Select, TimePicker } from "antd";
import { Clock, DollarSign } from "lucide-react";
import { TimeInputWithAmPm } from "@components/TimeInputWithAmPm";

interface AdsTimeBudgetFormProps {
  formId: string;
  onSubmit?: () => void;
}

const campaignTypeOptions = [
  { value: "sponsored_products", label: "Sponsored Products" },
  { value: "sponsored_brands", label: "Sponsored Brands" },
  { value: "sponsored_display", label: "Sponsored Display" },
  { value: "sponsored_video", label: "Sponsored Video" },
  { value: "sponsored_brands_video", label: "Sponsored Brands Video" },
];

const campaigns = [
  {
    value: "campaign_1",
    label: "Campaign A",
  },
  {
    value: "campaign_2",
    label: "Campaign B",
  },
  {
    value: "campaign_3",
    label: "Campaign C",
  },
  {
    value: "campaign_4",
    label: "Campaign D",
  },
  {
    value: "campaign_5",
    label: "Campaign E",
  },
];

export const AdsTimeBudgetForm: React.FC<AdsTimeBudgetFormProps> = ({
  formId,
  onSubmit,
}) => {
  const { initializeForm, resetForm, updateFormField, formData } =
    useFormStore();

  const handleCampaignTypeChange = (value: string) => {
    updateFormField(formId, "campaignType", value);
  };

  const handleCampaignChange = (value: string) => {
    updateFormField(formId, "campaign", value);
  };

  const handleTimeFromChange = (value: string) => {
    updateFormField(formId, "performingHoursFrom", value);
  };

  const handleTimeToChange = (value: string) => {
    updateFormField(formId, "performingHoursTo", value);
  };

  useEffect(() => {
    initializeForm(formId, {
      campaignType: "",
      campaigns: "",
      budgetConsumption: "",
      budgetDepletionRate: "",
      missedImpressions: "",
      conversionRateByHour: "",
      performingHoursFrom: "",
      performingHoursTo: "",
    });

    return () => resetForm(formId);
  }, [formId, initializeForm, resetForm]);

  const campaignTypeValue = formData[formId]?.campaignType || "";
  const campaignValue = formData[formId]?.campaigns || "";
  const timeFromValue = formData[formId]?.performingHoursFrom || "";
  const timeToValue = formData[formId]?.performingHoursTo || "";

  return (
    <div className={styles.addSkuContainer}>
      <div className={styles.row}>
        <div className={styles.selectWrapper}>
          <label className={styles.fieldLabel}>Campaign</label>
          <Select
            placeholder="Select Campaign"
            value={campaignValue || undefined}
            onChange={handleCampaignChange}
            options={campaigns}
            className={styles.typeSelect}
            style={{ width: "100%" }}
          />
        </div>
        <div className={styles.selectWrapper}>
          <label className={styles.fieldLabel}>Campaign type</label>
          <Select
            placeholder="Select Campaign type"
            value={campaignTypeValue || undefined}
            onChange={handleCampaignTypeChange}
            options={campaignTypeOptions}
            className={styles.typeSelect}
            style={{ width: "100%" }}
          />
        </div>
      </div>

      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="budgetConsumption"
          label="Time-Based Budget Consumption"
          placeholder=""
          type="number"
          size="small"
          icon={<DollarSign size={20} color="#7C7C78" />}
        />
        <FormField
          formId={formId}
          fieldName="budgetDepletionRate"
          label="Budget Depletion Rate, %"
          placeholder=""
          type="number"
          size="small"
        />
      </div>

      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="missedImpressions"
          label="Missed Impressions Due to Budget Cap"
          placeholder=""
          type="number"
          size="small"
        />
        <FormField
          formId={formId}
          fieldName="conversionRateByHour"
          label="Conversion Rate by Hour, %"
          placeholder=""
          type="number"
          size="small"
        />
      </div>

      <div className={styles.row}>
        <TimeInputWithAmPm
          label="Best Performing Hours from"
          value={timeFromValue as string}
          onChange={handleTimeFromChange}
        />
        <TimeInputWithAmPm
          label="Best Performing Hours to"
          value={timeToValue as string}
          onChange={handleTimeToChange}
        />
      </div>
    </div>
  );
};
